import Base from 'app/views/base';

import { showSuccess } from 'utils/messages';
import { displayErrorsOnView, displayErrorOnField, clearPopoversOnView } from 'utils/forms';
import tmpl from 'templates/user_edit_password';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #user_edit_password': 'submit',
  },

  initialize() {
    this.listenTo(this.model, 'change', this.render);
  },

  beforeRender() {
    clearPopoversOnView(this);
  },

  submit(e) {
    e.preventDefault();

    const self = this;
    this.model.update({
      current_password: this.$('#user_current_password').val(),
      password: this.$('#user_password').val(),
      password_confirmation: this.$('#user_password_confirmation').val(),
    }, {
      success(model) {
        self.render();
        model.trigger('change');
        showSuccess('Password successfully updated');
      },
      error(model, response) {
        self.render();
        const errors = JSON.parse(response.responseText).error.errors;
        displayErrorsOnView(self, errors, ['current_password', 'password', 'password_confirmation']);
      },
    });
  },

  setFocus(attribute) {
    this.$(`#user_${attribute}`).focus();
  },

  displayError(attribute, message) {
    const formField = this.$(`#user_${attribute}`);
    displayErrorOnField(formField, message);
  },
});



// WEBPACK FOOTER //
// ./app/views/user_edit_password_view.js